import type { FeatureMode } from '@/services/content';

import styles from './ModeSelector.module.css';

const OPTIONS: { value: FeatureMode; label: string; title: string }[] = [
  { value: 'off', label: 'Off', title: 'Desligado' },
  { value: 'semi', label: 'Semi', title: 'Gatilho vira card; você gera com framming' },
  { value: 'auto', label: 'Auto', title: 'Gera sozinho no gatilho' },
];

export function ModeSelector({
  value,
  onChange,
  disabled,
  exclude = [],
}: {
  value: FeatureMode;
  onChange: (mode: FeatureMode) => void;
  disabled?: boolean;
  exclude?: FeatureMode[];
}) {
  return (
    <div className={styles.root} role="group" aria-label="Modo de geração">
      {OPTIONS.filter((o) => !exclude.includes(o.value)).map((o) => (
        <button
          key={o.value}
          type="button"
          title={o.title}
          disabled={disabled}
          className={`${styles.seg} ${value === o.value ? styles.active : ''} ${
            o.value === 'auto' && value === 'auto' ? styles.activeAuto : ''
          }`}
          onClick={() => onChange(o.value)}
          aria-pressed={value === o.value}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
